import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=2b49c286&scoped=true"
import script from "./verify.vue?vue&type=script&lang=js"
export * from "./verify.vue?vue&type=script&lang=js"
import style0 from "./verify.vue?vue&type=style&index=0&id=2b49c286&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b49c286",
  null
  
)

export default component.exports